import { Scope } from '@utils';

const MAX_DOTS = 3;

type EventLike = { id: string; scope: string };

/**
 * Returns the dot color for a given scope string.
 * PROFESSIONAL -> theme.colors.primary (blue)
 * PRIVATE      -> theme.colors.green
 * GHOST / any  -> theme.colors.secondary (grey)
 */
const getDotColor = (scope: string, theme: any): string => {
  const upper = scope?.toUpperCase();
  if (upper === Scope.PROFESSIONAL) return theme.colors.primary;
  if (upper === Scope.PRIVATE) return theme.colors.green;
  return theme.colors.secondary; // GHOST or other
};

/**
 * Build a deduplicated, max-3 array of dot descriptors for react-native-calendars
 * and for the web custom day rendering.
 *
 * Deduplication: only one dot per unique color.
 * Cap: maximum 3 dots.
 */
export const buildMultiDots = <T extends EventLike>(
  events: T[],
  theme: any,
): { key: string; color: string; selectedDotColor: string }[] => {
  const seen = new Set<string>();
  const dots: { key: string; color: string; selectedDotColor: string }[] = [];

  for (const event of events) {
    if (dots.length >= MAX_DOTS) break;
    const color = getDotColor(event.scope, theme);
    if (seen.has(color)) continue;
    seen.add(color);
    dots.push({
      key: event.id,
      color,
      selectedDotColor: color,
    });
  }

  return dots;
};

export { getDotColor, MAX_DOTS };
